import {
    AtSign,
    CheckMark,
    Cloud,
    Infinity,
    LinkParam,
    PencilEdit,
    PlusUser,
    RedCross,
} from '@webapp/common/assets/icons';
import { Tooltip } from '@webapp/common/components/tooltip';
import { LicenseNames, LicenseType } from '@webapp/common/resources/entities/license';

import ClockIcon from '@webapp/landing/src/components/ui/icons/clock.svg';

import css from './plan/plan.css';

export const getPlans = (mounted: boolean) => [
    {
        header: LicenseNames[LicenseType.ONETIME],
        hint: <span>за опрос</span>,
        price: 8990,
        items: [
            {
                icon: <Infinity />,
                text: 'Вопросов, страниц, фильтров',
                selected: true,
            },
            {
                icon: <PencilEdit />,
                text: '1 опрос, 10 000 ответов',
            },
            {
                icon: <Cloud />,
                text: 'Хранилище 2 Гб ',
            },
            {
                icon: <AtSign />,
                text: 'Рассылка до 2 000 всего',
            },
            {
                icon: <PlusUser />,
                text: (
                    <div className={css.tooltipWrap}>
                        Панель респондентов{' '}
                        {mounted && (
                            <Tooltip clickable={true} withTooltipIcon={true}>
                                Возможность сбора ответов по сторонней целевой аудитории для исследовательских опросов -
                                {` `}
                                <a href='/ru/respondent-panel' target='_blank'>
                                    подробнее
                                </a>
                            </Tooltip>
                        )}
                    </div>
                ),
            },
            {
                icon: <LinkParam />,
                text: '1 параметр ссылки',
            },
            {
                icon: <ClockIcon />,
                text: '60 дней',
            },
            {
                icon: <RedCross />,
                text: 'API',
            },
            {
                icon: <RedCross />,
                text: 'Продвинутая аналитика',
            },
            {
                icon: <RedCross />,
                text: 'Продвинутая логика',
            },
            {
                icon: <RedCross />,
                text: 'Сохранение незавершённых ответов',
                className: css.red,
            },
            {
                icon: <RedCross />,
                text: 'Оффлайн режим',
                className: css.red,
            },
            {
                icon: <RedCross />,
                text: 'Свой SMTP',
                className: css.red,
            },
        ],
    },
    {
        header: LicenseNames[LicenseType.FOR_YEAR],
        hint: <span>за админа ЛК</span>,
        price: 49990,
        items: [
            {
                icon: <Infinity />,
                text: 'Вопросов, страниц, фильтров',
                selected: true,
            },
            {
                icon: <Infinity />,
                text: 'Опросов, ответов',
                selected: true,
            },
            {
                icon: <Cloud />,
                text: 'Хранилище 10 Гб ',
            },
            {
                icon: <AtSign />,
                text: 'Рассылка до 10 000 в сутки',
            },
            {
                icon: <PlusUser />,
                text: (
                    <div className={css.tooltipWrap}>
                        Панель респондентов{' '}
                        {mounted && (
                            <Tooltip clickable={true} withTooltipIcon={true}>
                                Возможность сбора ответов по сторонней целевой аудитории для исследовательских опросов -
                                {` `}
                                <a href='/ru/respondent-panel' target='_blank'>
                                    подробнее
                                </a>
                            </Tooltip>
                        )}
                    </div>
                ),
            },
            {
                icon: <LinkParam />,
                text: '1 параметр ссылки',
            },
            {
                icon: <ClockIcon />,
                text: '1 год',
            },
            {
                icon: <RedCross />,
                text: 'API',
                className: css.red,
            },
            {
                icon: <RedCross />,
                text: 'Продвинутая аналитика',
            },
            {
                icon: <RedCross />,
                text: 'Продвинутая логика',
            },
            {
                icon: <RedCross />,
                text: 'Сохранение незавершённых ответов',
                className: css.red,
            },
            {
                icon: <RedCross />,
                text: 'Оффлайн режим',
                className: css.red,
            },
            {
                icon: <RedCross />,
                text: 'Свой SMTP',
                className: css.red,
            },
        ],
    },
    {
        header: (
            <span>
                <span>{LicenseNames[LicenseType.FOR_YEAR_PLUS]}</span>
                <span> PRO+</span>
            </span>
        ),
        hint: <span>за админа ЛК</span>,
        price: 94990,
        items: [
            {
                icon: <Infinity />,
                text: 'Вопросов, страниц, фильтров',
                selected: true,
            },
            {
                icon: <Infinity />,
                text: 'Опросов, ответов',
                selected: true,
            },
            {
                icon: <Cloud />,
                text: 'Хранилище 15 Гб ',
            },
            {
                icon: <AtSign />,
                text: 'Рассылка до 15 000 в сутки',
            },
            {
                icon: <PlusUser />,
                text: (
                    <div className={css.tooltipWrap}>
                        Панель респондентов
                        {mounted && (
                            <Tooltip clickable={true} withTooltipIcon={true}>
                                Возможность сбора ответов по сторонней целевой аудитории для исследовательских опросов -
                                {` `}
                                <a href='/ru/respondent-panel' target='_blank'>
                                    подробнее
                                </a>
                            </Tooltip>
                        )}
                    </div>
                ),
            },
            {
                icon: <LinkParam />,
                text: (
                    <div className={css.tooltipWrap}>
                        50 параметров ссылки
                        {mounted && (
                            <Tooltip withTooltipIcon={true}>
                                Возможность передачи скрытых параметров, которые заранее известны о респонденте.
                                Например id пользователя, точка продаж, департамент и т.п Также используя параметры
                                можно настраивать логику показа вопросов и передавать значения параметров в текст
                                рассылки и опроса
                            </Tooltip>
                        )}
                    </div>
                ),
            },
            {
                icon: <ClockIcon />,
                text: '1 год',
            },
            {
                icon: <CheckMark />,
                text: (
                    <div className={css.tooltipWrap}>
                        API
                        {mounted && (
                            <Tooltip withTooltipIcon={true}>
                                Возможность реализации любых интеграций с вашими CRM, базами данных и т.п
                            </Tooltip>
                        )}
                    </div>
                ),
                className: css.green,
            },
            {
                icon: <CheckMark />,
                text: (
                    <div className={css.tooltipWrap}>
                        Продвинутая аналитика
                        {mounted && (
                            <Tooltip clickable={true} withTooltipIcon={true}>
                                Возможность построения кросс-таблиц -{` `}
                                <a href='/ru/help?#kak-postroit-kross-tablitsu-po-rezultatam-oprosa' target='_blank'>
                                    подробнее
                                </a>
                            </Tooltip>
                        )}
                    </div>
                ),
                className: css.green,
            },
            {
                icon: <CheckMark />,
                text: (
                    <div className={css.tooltipWrap}>
                        Продвинутая логика{' '}
                        {mounted && (
                            <Tooltip withTooltipIcon={true}>
                                <div>
                                    Продвинутая логика позволяет добавить условие при сочетании определенных ответов на
                                    разные вопросы.
                                </div>
                                <div>
                                    Например: Если в вопросе №1 выбран вариант ответа &quot;Мужчина&quot; и в вопросе №5
                                    вариант ответа &quot;Не пользовался данной услугой&quot;,
                                </div>
                                респондент должен пропустить вопросы №9, №10 и после ответа на все вопросы увидеть
                                индивидуальный текст завершения
                            </Tooltip>
                        )}
                    </div>
                ),
                className: css.green,
            },
            {
                icon: <CheckMark />,
                text: (
                    <div className={css.tooltipWrap}>
                        Сохранение незавершённых ответов
                        {mounted && (
                            <Tooltip iconClassName={css.saveAnswersIcon} clickable={true} withTooltipIcon={true}>
                                Возможность сохранения ответа респондента поэтапно (по мере заполнения) -{` `}
                                <a
                                    href='/ru/help?#kak-rabotayet-nastroyka-po-sokhraneniyu-nezavershennykh-otvetov'
                                    target='_blank'
                                >
                                    подробнее
                                </a>
                            </Tooltip>
                        )}
                    </div>
                ),
                className: css.green,
            },
            {
                icon: <CheckMark />,
                text: (
                    <div className={css.tooltipWrap}>
                        Оффлайн режим
                        {mounted && (
                            <Tooltip withTooltipIcon={true}>
                                Возможность собирать ответы локально на устройстве без подключения к интернету. Обычно
                                используется для полевых социологических исследованиях
                            </Tooltip>
                        )}
                    </div>
                ),
                className: css.green,
            },
            {
                icon: <CheckMark />,
                text: (
                    <div className={css.tooltipWrap}>
                        Свой SMTP
                        {mounted && (
                            <Tooltip withTooltipIcon={true}>
                                Если используете имейл рассылку с Тестографа, то возможно подключение своего
                                корпоративного ящика в качестве имение отправителя
                            </Tooltip>
                        )}
                    </div>
                ),
                className: css.green,
            },
        ],
    },
];
